"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("@mui/material"),o=require("@mui/material/styles"),n=o.styled(r.Typography)(({theme:e})=>({color:e.palette.grey[700],transform:"translateY(-8px)"})),p=49,a=o.styled("div")(({theme:e,top:t})=>`
  position: absolute;
  pointer-events: none;
  z-index: 4;
  left: ${p}px;
  width: ${`calc(100% - ${p}px)`};
  top: ${t||0}%;

  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: ${e.palette.error[500]};
  }

  &:before {
    width: 100%;
    height: 1px;
  }

  &:after {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    top: -5px;
    left: -5px;
  }
`),l=o.styled(r.Paper)(({theme:e,offset:t})=>`
  width: ${p}px;
  flex-shrink: 0;
  text-align: center;
  border-radius: 8px 0 0 8px;
  background: ${e.palette.common.white};
  padding-top: ${t||0}px;
`),s=o.styled("div")(({theme:e,height:t,lineWidth:i})=>`
  height: ${t}px;
  position: relative;

  &:before {
    content: '';
    z-index: 1;
    position: absolute;
    display: block;
    pointer-events: none;
    left: ${p}px;
    top: 0;
    height: 1px;
    background: ${e.palette.grey[300]};
    width: ${i??1e4}px;
  }

  &:after {
    content: '';
    position: absolute;
    display: block;
    right: 0;
    top: 0;
    width: 3px;
    height: 1px;
    background: ${e.palette.grey[300]};
  }
`),d=o.styled(r.Typography)(({theme:e})=>({color:e.palette.error[500],position:"absolute",left:"-48px",top:"-9px",zIndex:3,background:e.palette.common.white,padding:"2px 4px"}));exports.ColumnWrapper=l;exports.IntervalWrapper=s;exports.TimeDetails=n;exports.TimeIndicatorInfo=d;exports.TimeIndicatorWrapper=a;
